module.exports = __webpack_public_path__ + "static/media/13.e7b44cc6.jpeg";